"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.TermsAndConditions = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactRedux = require("react-redux");
var _helpers = require("@PetSureAustralia/petsure-react-ui-library/distLib/helpers");
var _selectors = require("../../../store/quote/selectors");
var _brandContext = require("../../../contextProviders/brandContext");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/* eslint-disable max-len */
/* eslint-disable react/forbid-prop-types */

var TermsAndConditions = exports.TermsAndConditions = function TermsAndConditions(_ref) {
  var totalAmount = _ref.totalAmount;
  var _useContext = (0, _react.useContext)(_brandContext.BrandContext),
    _useContext$activeBra = _useContext.activeBrandContext,
    broker = _useContext$activeBra.brand.broker,
    termsAndConditions = _useContext$activeBra.steps.summary.petSummary.termsAndConditions;
  var _useSelector = (0, _reactRedux.useSelector)(_selectors.savedQuoteSelector),
    quote = _useSelector.quote;
  var owner = quote.owner;
  var selectedPaymentFrequency = (0, _helpers.Capitalize)(quote.paymentFrequency);
  return /*#__PURE__*/_react["default"].createElement("div", null, termsAndConditions && termsAndConditions(totalAmount, selectedPaymentFrequency, (0, _helpers.Capitalize)(broker), owner));
};
TermsAndConditions.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  totalAmount: _propTypes["default"].number
};